import React from "react";
import { Box, Chip, Typography } from "@material-ui/core";

import { i18n } from "../../translate/i18n";
import { getContactWalletUsers, isRestrictedContact } from "../../utils/contactWallet";

const ContactWalletInfo = ({ contact, compact = false, showTitle = false }) => {
  const walletUsers = getContactWalletUsers(contact);
  const restricted = isRestrictedContact(contact);

  return (
    <Box mt={compact ? 1 : 0}>
      {showTitle && (
        <Typography variant="subtitle2" color="textSecondary" gutterBottom>
          {i18n.t("contactDrawer.wallet.title")}
        </Typography>
      )}
      <Box display="flex" flexWrap="wrap" gridGap={8}>
        <Chip
          size="small"
          color={restricted ? "secondary" : "primary"}
          variant={restricted ? "default" : "outlined"}
          label={
            restricted
              ? i18n.t("contactDrawer.wallet.restricted")
              : i18n.t("contactDrawer.wallet.public")
          }
        />
        {walletUsers.map((user) => (
          <Chip
            key={`${user.id || user.name}`}
            size="small"
            variant="outlined"
            label={user.name}
          />
        ))}
      </Box>
      {compact && walletUsers.length === 0 && (
        <Typography variant="caption" color="textSecondary">
          {i18n.t("contactDrawer.wallet.publicDescription")}
        </Typography>
      )}
    </Box>
  );
};

export default ContactWalletInfo;
